import con from '../../../../connection';
import company from './company';
var path = '/operations';
var operations = function (url) { return function () { return ({
    // 操作ログ登録
    post: function (param) { return con.post(url + path, param); },
    company: company(url + path),
}); }; };
export default operations;
